var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filters"},[_c('h1',[_vm._v("Project Filters")]),_vm._v(" "),_vm._l((_vm.project.filters),function(filter){return _c('ProjectFilterForm',{key:filter.key,attrs:{"filter":filter},on:{"delete-filter":_vm.deleteFilter}})})],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd31f1b2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/ProjectFilters.vue
// module id = null
// module chunks = 